import ApiService from '../../core/services/ApiService';
import { UsersitePlansGetSearchChoiceTypePayload } from '~/models/schema';

const SEARCH_CHOICE = '/api/v1/plans/search_choice';

class PlanApiService extends ApiService {
  public fetchSearchChoice(): Promise<UsersitePlansGetSearchChoiceTypePayload> {
    return this.request(SEARCH_CHOICE, this.METHOD.GET);
  }
}

export default PlanApiService;
